import { createGlobalStyle } from "styled-components"

const GlobalStyles = createGlobalStyle`
 :root {

--swiper-pagination-color:#FFC30B;
    --swiper-theme-color: #ffffff;
    --swiper-navigation-color: #FFC30B;
	--white: #FFC30B;//FDEDD3
	--yellow: #FFC30B;
	--pink: #F451AE;
	--green: #4e5220;
	--blue: #DAF6FF;
	--black: #000000;
	--borderblack: 1px solid var(--mfblack);
  --orange: #FC970B;
}

body::-webkit-scrollbar, html::-webkit-scrollbar {
    display: none;
}

html {
	background: var(--black);
	overflow-x: hidden;
	font-size: 16px;
	line-height:1.7
}

body {
	font-size: 1rem;
	font-family: 'PPNeue', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	
	transition: opacity .3s ease-in;
	width: 100vw;
	overflow-x: hidden;
	
	.cutoff {
		
		overflow-x: hidden;
		max-width: 100vw;
		min-height:100vh;
		margin-top: 80px;
		@media (min-width: 768px) {
  		  margin-top: 108px;
 		 }	
	}
}

a {
	text-decoration: underline;
  :visited{
    color:unset;
  }
  
}


fieldset {
	border-color: rgba(0, 0, 0, 0.1);
	border-width: 1px;
}

button {}

textarea:focus,
input:focus {
	outline: none;
}

hr {
	border: 0;
	height: 8px;
	background-size: 1500px;
}

img {
	max-width: 100%;
}

.wrapper-full {
	margin-left: auto;
	margin-right: auto;
}

.grid16 {
	display: grid;
	grid-template-columns: repeat(16, [col-start] 1fr);
}
.grid24 {
	display: grid;
	grid-template-columns: repeat(24, [col-start] 1fr);
}

/*! locomotive-scroll v4.1.3 | MIT License | https://github.com/locomotivemtl/locomotive-scroll */
html.has-scroll-smooth {
  overflow: hidden; }

html.has-scroll-dragging {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; }

.has-scroll-smooth body {
  overflow: hidden; }

.has-scroll-smooth [data-scroll-container] {
  min-height: 100vh; }

[data-scroll-direction="horizontal"] [data-scroll-container] {
  height: 100vh;
  display: inline-block;
  white-space: nowrap; }

[data-scroll-direction="horizontal"] [data-scroll-section] {
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  height: 100%; }

.c-scrollbar {
  position: absolute;
  right: 0;
  top: 0;
  width: 11px;
  height: 100%;
  transform-origin: center right;
  transition: transform 0.3s, opacity 0.3s;
  opacity: 0; }
  .c-scrollbar:hover {
    transform: scaleX(1.45); }
  .c-scrollbar:hover, .has-scroll-scrolling .c-scrollbar, .has-scroll-dragging .c-scrollbar {
    opacity: 1; }
  [data-scroll-direction="horizontal"] .c-scrollbar {
    width: 100%;
    height: 10px;
    top: auto;
    bottom: 0;
    transform: scaleY(1); }
    [data-scroll-direction="horizontal"] .c-scrollbar:hover {
      transform: scaleY(1.3); }

.c-scrollbar_thumb {
  position: absolute;
  top: 0;
  right: 0;
  background-color: black;
  opacity: 0.5;
  width: 7px;
  border-radius: 10px;
  margin: 2px;
  cursor: -webkit-grab;
  cursor: grab; }
  .has-scroll-dragging .c-scrollbar_thumb {
    cursor: -webkit-grabbing;
    cursor: grabbing; }
  [data-scroll-direction="horizontal"] .c-scrollbar_thumb {
    right: auto;
    bottom: 0; }
`

export default GlobalStyles
